import type ApiContent from 'src/core/models/api/ApiContent';
import Translations from 'src/core/utils/Translations';

const META_SEPARATOR = ' · ';

export const exerciseMetaLine = (exercise: ApiContent): string | null => {
	const duration = exercise.duration_minutes === null ? null : Translations.durationMinutes(exercise.duration_minutes);
	const category = exercise.categories[0]?.name ?? null;

	if (category === null) {
		return duration;
	}

	return duration === null ? category : `${duration}${META_SEPARATOR}${category.toLowerCase()}`;
};
